export default __webpack_public_path__ + "static/construction-banner-29d8642171be0a01c28cc8ac76bf66d5.png";